import React, { useState, useEffect } from "react";
import Pagebannerintern from "../components/pagebanner-intern.js";
// Import de l'ID du compte pour pouvoir effectuer les requêtes Steam
import { steamid } from "../api-keys/steam-api.js";
// Import des icones
import Achievement from "../icons/achievement.js";

export default function OwnedGames({}) {
    const [owned, setOwned] = useState([]);
    // Variable pour les jeux Steam
    const [gamess, setGamess] = useState([]);
    // Variable pour les jeux PSN
    const [PsnGames, setPsnGames] = useState([]);
    // Variable pour actualiser les filtres du formulaire
    const [formFilters, setFormFilters] = useState("");

    const delay = ms => new Promise(r => setTimeout(r, ms));

    async function GetStatistics(appid) {
        const url = `/.netlify/functions/get-game-stats?steamid=${steamid}&appid=${appid}`;
        let response = await fetch(url);
        if (response.status === 400) { setOwned(prev => [...prev, { appid, error: true, stats: [] }]); return; }
        if (response.status === 429) { await delay(200); response = await fetch(url); }
        const { playerstats } = await response.json();
        if (!playerstats) return;
        // … mapping des noms custom (ton code existant) …
        setOwned(prev => [...prev, { ...playerstats, appid }]);
    }

    async function GetOwnedGamesIdList() {
        const url = `/.netlify/functions/get-owned-games?steamid=${steamid}`;
        let res = await fetch(url);
        if (res.status === 429) { await delay(100); res = await fetch(url); }
        const data = await res.json();
        const games = data?.response?.games || [];
        setGamess(games);
        const ids = games.map(g => g.appid);
        for (const id of ids) { await GetStatistics(id); await delay(1000); }
    }

    async function getPsnGames() {
        await fetch(`/.netlify/functions/psn-games`) // ton endpoint backend
        .then((res) => res.json())
        .then((data) => setPsnGames(data.trophyTitles))
        .catch(err => console.error('Fetch psn-games error:', err));
    }

    function sortElementsByDataName() {
        const list = document.querySelector('.gamesList'); // cible la liste
        const items = Array.from(list.children);

        items.sort((a, b) => {
            return a.dataset.name.localeCompare(b.dataset.name, undefined, { sensitivity: 'base' });
        });

        // Réinjecte les éléments dans l'ordre trié
        items.forEach(item => list.appendChild(item));
    }

    useEffect(() => { 
        console.log("ca marche");
        GetOwnedGamesIdList(); 
        getPsnGames();
    }, []);

    useEffect(() => {
        sortElementsByDataName();
    }, [gamess , PsnGames]);

    return (
        <div className="games">
             <Pagebannerintern breadcrumb="Jeux" title="Liste de jeux" />

            <div className="container">
                <div className="row">
                    <div className="col-12 mt-3 mb-3">
                        <p className="mb-3">À première vue, exposer sa boutique de jeux n’a pas l’air franchement professionnel pour un portfolio, mais de mon point de vue, c’est tout l’inverse.</p>
                        <p className="mb-3">J’ai personnellement toujours voulu trouver un moyen d’afficher ma boutique de jeux Steam sans que la personne concernée ait besoin d’un compte. J’en ai donc profité pour m’intéresser de près à la documentation de l’API officielle de Steam.</p>
                        <p className="mb-3">Pour un développeur qui n’a jamais vraiment travaillé sur la gestion ou la connexion à une API, c’était une aubaine !</p>
                        <p>C'était donc une occasion en or pour développer mes compétences sur cet aspect tout en travaillant sur un projet de passion.</p>
                    </div>
                </div>
                <form className="games-selector mb-3">
                    <select
                     name="selectedPlateform" 
                     id="selectedPlateform" 
                     value={formFilters}
                     onChange={(e) => {setFormFilters(e.target.value)}}>
                        <option value="">Sélectionnez une plateforme</option>
                        <option value="PS3">PS3</option>
                        <option value="PS4">PS4</option>
                        <option value="steam">STEAM</option>
                    </select>
                </form>
                <div className={`row gamesList${" "+formFilters}`}>
                    {gamess.map((e, i) => (
                        <div 
                         key={i}
                         className="col-12 col-sm-6 col-lg-4 game-container" 
                         data-appid={e.appid} 
                         data-platform="steam"
                         data-name={e?.name}>
                            <div className="img-cover h-100" style={{
                                backgroundImage: `url(https://cdn.cloudflare.steamstatic.com/steam/apps/${e.appid}/header.jpg)`,
                                backgroundPosition: 'center',
                                backgroundSize: 'cover'
                                }}>
                                <div className="game-name fw-semibold">{e?.name}</div>
                                <div className="game-duration d-flex align-items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="me-2"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                                    {Math.floor(e.playtime_forever / 60)} Heure{(Math.floor(e.playtime_forever / 60)) > 1 && (
                                        <span>s</span>
                                    )}
                                </div>
                                <div className="game-plateform game-plateform-steam">STEAM</div>
                                <div className="game-achievement d-flex align-items-center">
                                    <Achievement />
                                    {owned[i]?.achievements?.length ?? 0}
                                </div>
                            </div>
                        </div>
                    ))}
                    {PsnGames.map((e, i) => (
                        <div 
                         key={i} 
                         className="col-12 col-sm-6 col-lg-4 game-container" 
                         data-appid={i} 
                         data-platform={e?.trophyTitlePlatform}
                         data-name={e?.trophyTitleName}>
                            <div className="img-cover h-100" style={{
                                backgroundImage: `url(${e?.trophyTitleIconUrl})`,
                                backgroundPosition: 'center',
                                backgroundSize: 'cover'
                                }}>
                                <div className="game-name fw-semibold">{e?.trophyTitleName}</div>
                                <div className={`game-plateform game-plateform-${e?.trophyTitlePlatform}`}>{e?.trophyTitlePlatform}</div>
                                <div className="game-achievement d-flex align-items-center">
                                    <Achievement />
                                    {(e?.earnedTrophies.bronze + e?.earnedTrophies.platinum + e?.earnedTrophies.silver + e?.earnedTrophies.gold) ?? 0}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}